import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectAvodComponent } from './components/project-avod/project-avod.component';
import { ProjectAvodCatalogComponent} from "@catmodels/avod-catalog/components/project-avod-catalog/project-avod-catalog.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIFormModule} from "@catuiform/ui-form.module";
import {UIBaseModule} from "@catui/ui-base.module";
import {ProjectAvodService} from "@catmodels/project-avod/services/project-avod.service";
import {ExplorerModule} from "@catmodules/widgets/explorer/explorer.module";
import {RouterModule} from "@angular/router";

const publicComponents = [
  ProjectAvodComponent,
];

const exportings = [...publicComponents];

const imports = [
  CommonModule,
  RouterModule,
  FormsModule,
  UIBaseModule,
  UIFormModule,
  ReactiveFormsModule,
  ExplorerModule,
]

const declarations = [...publicComponents];
const providers = [ProjectAvodService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class ProjectAvodModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-avod/project-avod.module.ts